var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsdt = function SvgUsdt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#50AF95"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.466 7.846c-.054.004-.328.02-.939.02-.486 0-.83-.015-.952-.02-1.879-.083-3.28-.41-3.28-.801s1.401-.719 3.28-.803V7.52c.123.009.475.03.96.03.584 0 .876-.025.929-.03V6.243c1.874.084 3.274.41 3.274.802 0 .39-1.4.717-3.274.8zm0-1.735V4.968h2.616V3.225H3.959v1.743h2.616v1.143c-2.127.097-3.725.519-3.725 1.023 0 .505 1.598.926 3.725 1.024v3.663h1.89V8.156c2.121-.097 3.717-.518 3.717-1.022s-1.594-.925-3.717-1.023",
    clipRule: "evenodd"
  })));
};
export default SvgUsdt;